import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { OnScreenMessagingService } from '@pattern-library/onscreen-messaging/onscreen-messaging.service';
import { LoggingService } from '@logging/logging.service';
import { ErrorHandlerService } from '@utils/error-handler.service';
import { AbstractEntityStateService } from '@entity-framework/entity-record/state/abstract-entity.state-service';
import { ForgotPasswordDataProvider } from './forgot-password.data-provider';
import { ForgotPasswordFormData } from './forgot-password.model';

@Injectable()
export class ForgotPasswordStateService extends AbstractEntityStateService<ForgotPasswordFormData> {
    private static storeName = 'forgot-password';

    constructor(
        protected override dataProvider: ForgotPasswordDataProvider,
        protected override route: ActivatedRoute,
        errorHandler: ErrorHandlerService,
        protected override messaging: OnScreenMessagingService,
        protected override logger: LoggingService,
        private formBuilder: FormBuilder
    ) {
        super(ForgotPasswordStateService.storeName, dataProvider, route, errorHandler, messaging, logger);
    }

    setUpForm() {
        this.bindFormGroup((forgotPasswordFormData: ForgotPasswordFormData | undefined) => {
            this.logger.trace('ForgotPasswordStateService: binding form to entity models: ', forgotPasswordFormData);
            return this.createForm();
        });
    }

    public createForm() {
        return this.formBuilder.group({
            emailAddress: ['', [Validators.required, Validators.email]]
        });
    }
} 